import { Link, usePage } from '@inertiajs/react'

const tabs = [
  { href: '/admin/research/events', label: 'Events' },
  { href: '/admin/research/organizations', label: 'Organizations' },
  { href: '/admin/research/sponsors', label: 'Sponsors' },
  { href: '/admin/research/honorees', label: 'Honorees' },
  { href: '/admin/research/gala_committee_members', label: 'Gala Committee' },
  { href: '/admin/research/host_committee_members', label: 'Host Committee' },
  { href: '/admin/research/venues', label: 'Venues' },
  { href: '/admin/research/reports', label: 'Event Analytics' },
  { href: '/admin/research/custom_fields', label: 'Field Config' },
  { href: '/admin/research/import', label: 'Import' },
]

export default function ResearchNav() {
  const url = usePage().url

  function isActive(href: string) {
    if (url === '/admin/research' || url.startsWith('/admin/research?')) {
      return href === '/admin/research/events'
    }
    return url.startsWith(href)
  }

  return (
    <div className="mb-6 flex w-fit items-center gap-1 rounded-lg bg-muted/50 p-1">
      {tabs.map(tab => (
        <Link
          key={tab.href}
          href={tab.href}
          className={`rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${
            isActive(tab.href)
              ? 'bg-card text-foreground shadow-xs'
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          {tab.label}
        </Link>
      ))}
    </div>
  )
}
